<template>
  <div>
    <template v-if="(template === 'edit' || typeof template === 'undefined') && !field.readonly">
        <label :class="labelClass ? labelClass : 'u-label'">
          {{ field.label + (field.required ? '* ' : '') }}
        </label>
        <vue-dropzone
          v-on:vdropzone-file-added   = "fileAdded"
          v-on:vdropzone-removed-file = "fileRemoved"
          v-on:vdropzone-mounted      = "addExistingFiles"
          class                       = "dropzone-component"
          ref                         = "dropzone"
          :class                      = "'qa-' +field.name + '-field'"
          :id                         = "'js-dropzone-' + field.name"
          :options                    = "dropzoneOptions"
          :destroyDropzone            = "false"
        >
        </vue-dropzone>
    </template>
    <template v-if="template === 'detail' || field.readonly">
        <label :class="labelClass ? labelClass : 'u-label'">
          {{ field.label + (field.required ? '* ' : '') }}
        </label>
        <div class="c-uploaded-file" v-for="file in value">
          <span class="c-uploaded-file__title">
            {{ file.filename }}
          </span>
          <!--Desktop View-->
          <div class="c-uploaded-file__buttons u-remove-on-mobile u-remove-on-tablet">
            <button
              @click = "showFile(file,true)"
              class  = "c-uploaded-file__buttons__button t-link"
              target = "_blank"
            >
              {{ $t('web.field_file_upload.download_button_desktop') }}
            </button>
            <button
              @click = "showFile(file,false)"
              class  = "c-uploaded-file__buttons__button t-link"
              target = "_blank"
            >
              {{ $t('web.field_file_upload.open_button_desktop') }}
            </button>
          </div>
          <!--Mobile and Tablet Views-->
          <div class="c-uploaded-file__buttons u-remove-on-desktop">
            <button
              @click = "showFile(file,true)"
              class  = "c-uploaded-file__buttons__button t-link"
              target = "_blank"
            >
              {{ $t('web.field_file_upload.open_button_mobile') }}
            </button>
          </div>
        </div>
    </template>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import $ from 'jquery'
import _ from 'lodash'
import API from '@/services'
import util from '@/functions'

export default {
  props: ['field', 'value', 'labelClass', 'template'],
  components: {
    vueDropzone: vue2Dropzone
  },
  data () {
    return {
      dropzoneOptions: {
        url: 'ignore-me', // won't be used, but required for dropzone to work
        autoProcessQueue: false,
        autoQueue: false,
        thumbnailWidth: 200,
        thumbnailHeight: 200,
        thumbnailMethod: 'contain',
        clickable: true,
        addRemoveLinks: true,
        dictDefaultMessage: this.$t('web.field_file_upload.dropzone_message'),
        dictRemoveFile: this.$t('web.field_file_upload.dropzone_remove_file'),
        maxFiles: 20
      },
      // The property maxFiles is set to avoid issues with vue2-dropzone when adding/removing
      // files in claims with previously saved files, if maxFiles is not set, it defaults to null,
      // but removing an existing file which was manually added in addExistingFiles sets maxFiles to 1
      // which prevents adding any new files
      existingFiles: this.value
    }
  },

  updated () {
    // It's going to be called after claimModalData is updated with the correct claim information
    this.addExistingFiles()
  },

  methods: {
    showFile (file, download) {
      let url = 'files/' + file.id
      API.getAuthenticated(url, { responseType: 'blob' })
        .then((res) => {
          util.triggerFileDownload(res.data, file.filename, res.data.type, download)
        })
    },
    fileAdded (file) {
      $(file.previewElement).find('.dz-progress').hide()
      $(file.previewElement).find('.dz-size').hide()
      this.update()
    },
    fileRemoved (file) {
      _.each(this.existingFiles, (existingFile, i) => {
        if (typeof existingFile !== 'undefined' && existingFile.id === file.id) {
          this.existingFiles.splice(i, 1)
        }
      })
      this.update()
    },
    addExistingFiles () {
      this.existingFiles = this.value
      if (this.template === 'edit') {
        _.each(this.existingFiles, (file, i) => {
          var mockFile = { id: file.id, name: file.filename, size: 1 }
          this.$refs.dropzone.manuallyAddFile(mockFile, '/img/thm350.png')
        })
        this.update()
      }
    },
    update () {
      let files = this.$refs.dropzone.getAddedFiles()
      let value = []
      _.each(files, (file) => {
        value.push(file.name)
      })
      _.each(this.existingFiles, (file, i) => {
        value.push({id: file.id, name: file.filename})
      })
      if (value.length === 0) {
        value = null
      }
      this.$emit('input', value)
    }
  }
}
</script>
<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// FieldFileUpload.vue?e1bced50